// Single source of truth for the highlight color palette in this repo.
// KEEP IN SYNC with the extension's copy:
// luckynote-chrome-extension/src/shared/highlight-colors.js.
// Clients exchange color NAMES over the API; each surface maps names to its
// own rendering.

export const DEFAULT_HIGHLIGHT_COLOR = 'yellow';

// In-page paint colors used by the extension when marking text on a webpage.
// Unused by the web client today but kept for parity with the extension copy.
export const HIGHLIGHT_COLORS = {
    yellow: 'rgba(255, 224, 70, 0.55)',
    green: 'rgba(110, 231, 149, 0.5)',
    blue: 'rgba(125, 179, 255, 0.5)',
    pink: 'rgba(255, 143, 187, 0.5)'
};

// Quote-card tint used when rendering a saved highlight as a quote message
// (blockquote border + faint background).
export const HIGHLIGHT_QUOTE_THEME = {
    yellow: { border: '#E6C93F', background: 'rgba(255, 224, 70, 0.14)' },
    green: { border: '#5FCF80', background: 'rgba(110, 231, 149, 0.12)' },
    blue: { border: '#6FA8FF', background: 'rgba(125, 179, 255, 0.12)' },
    pink: { border: '#F17BA6', background: 'rgba(255, 143, 187, 0.12)' }
};
